[
  {
    "type": "website",
    "title": "The Hotel Media",
    "description": "A social platform for hotels, restaurants, banquets and nightlife venues on iOS, Android and the web. It combines realtime messaging, media sharing, live feeds and voice and video calling. I architected, built and deployed it, and published the mobile apps on the App Store and Google Play. Stack: Flutter, Next.js, Node.js, WebRTC, Firebase, MongoDB, Nginx, AWS.",
    "media": "https://apps.apple.com/in/app/the-hotel-media/id6670192036",
    "role": "Architecture, development & deployment",
    "year": "2025",
    "category": "Mobile",
    "image": "./Asset/img/projects/the-hotel-media.jpg"
  },
  {
    "type": "image",
    "title": "WebRTC Calling Stack",
    "description": "The custom voice and video calling system inside The Hotel Media. I engineered SDP negotiation, ICE with TURN and STUN servers, WebSocket signaling, and call handling across iOS and Android with FCM, APNs, CallKit and PushKit.",
    "media": "./Asset/img/projects/webrtc-calling.jpg",
    "role": "Realtime engineering",
    "year": "",
    "category": "Realtime",
    "image": "./Asset/img/projects/webrtc-calling.jpg"
  },
  {
    "type": "image",
    "title": "Logicxcel Cloud Infrastructure",
    "description": "Linux-based cloud environments at Logicxcel for backend services, AI workloads, automation systems and distributed data processing. I built and maintain the hosting for APIs, Apache PySpark services and internal platforms with HTTPS/TLS routing and reverse proxies, and handle SSH administration, deployment automation, domain hosting and monitoring. Stack: Linux, Nginx, Apache PySpark, Docker, Node.js, AWS, SSH.",
    "media": "./Asset/img/projects/logicxcel-cloud.jpg",
    "role": "Cloud infrastructure & deployment",
    "year": "2025–26",
    "category": "Cloud",
    "image": "./Asset/img/projects/logicxcel-cloud.jpg"
  },
  {
    "type": "image",
    "title": "Production Hosting on AWS",
    "description": "The production environment behind The Hotel Media’s communication services: AWS-hosted Linux servers with Nginx, HTTPS/TLS routing, PM2 process management and SSH deployment workflows.",
    "media": "./Asset/img/projects/production-hosting.jpg",
    "role": "DevOps",
    "year": "",
    "category": "Cloud",
    "image": "./Asset/img/projects/production-hosting.jpg"
  },
  {
    "type": "image",
    "title": "Web Push Notification Service",
    "description": "A Node.js backend automation service at Logicxcel that powers web push notifications.",
    "media": "./Asset/img/projects/web-push.jpg",
    "role": "Backend automation",
    "year": "2025–26",
    "category": "Backend",
    "image": "./Asset/img/projects/web-push.jpg"
  },
  {
    "type": "image",
    "title": "Salesforce Journey Builder Workflows",
    "description": "Node.js backend automation at Logicxcel that runs Salesforce Journey Builder workflows.",
    "media": "./Asset/img/projects/journey-builder.jpg",
    "role": "Backend automation",
    "year": "2025–26",
    "category": "Backend",
    "image": "./Asset/img/projects/journey-builder.jpg"
  }
]
